import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "searchSection",
  class: "flex-container-row gap10",
  style: {"align-items":"center","margin-bottom":"10px"}
}
const _hoisted_2 = { class: "flex-container-row gap10 filter-section search-filter" }
const _hoisted_3 = { style: {"font-weight":"bold"} }
const _hoisted_4 = { style: {"flex":"1"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.localize('searchFor')) + ":", 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_k_input, {
          modelValue: _ctx.internalSearchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalSearchText) = $event)),
          "show-clear-button": true,
          rounded: "full",
          class: "fw",
          onKeydown: _ctx.checkSearchSubmit
        }, null, 8, ["modelValue", "onKeydown"])
      ]),
      _createVNode(_component_k_button, {
        onClick: _ctx.onSearch,
        disabled: !_ctx.searchAllowed,
        class: "search-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.localize('search')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}